import { render } from "./ViewArchivedSnapshot.vue?vue&type=template&id=7754abca&scoped=true"
import script from "./ViewArchivedSnapshot.vue?vue&type=script&lang=js"
export * from "./ViewArchivedSnapshot.vue?vue&type=script&lang=js"

import "./ViewArchivedSnapshot.vue?vue&type=style&index=0&id=7754abca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7754abca"]])

export default __exports__